import { AfterViewInit, Component, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { CreatePage as ClientCreatePage } from 'src/app/clients/create/create.page';


@Component({
  selector: 'app-companies-contacts-select',
  templateUrl: './companies-contacts-select.page.html',
  styleUrls: ['./companies-contacts-select.page.scss'],
})
export class CompaniesContactsSelectPage implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(CdkVirtualScrollViewport) contactsViewport?: CdkVirtualScrollViewport;
  private contactsViewportResizeObserver?: ResizeObserver;
  companies: any[] = [];
  clients: any[] = [];
   @Input() source_header = 'Available';
  @Input() target_header = 'Selected To Add';
  @Input() modal_title = 'Select Contacts';

  @Input() selected_clients: any[] = [];
  @Input() selected_companies: any[] = [];
  @Input() selecting_for_default = false;
  @Input() default_client_guid = '';
  @Input() selecting_for_company = false;
  @Input() selecting_for_team_member = false;
  @Input() selecting_for_family = false;
  @Input() team_member_roles: any[] = [];
  @Input() roles: any[] = [];
  family_relationships: any[] = [];
  client_groups: any[] = [];
  company_groups: any[] = [];
  @Input() hide_companies = false;
  @Input() hide_contacts = false;

  show_empty_groups = false;


  constructor(
    private modalController: ModalController,
    private apiService: ApiService,
    public globalService: GlobalService,
    private ngZone: NgZone
  ) { }

  // The company info popup on hover. (mouseenter)/(mouseleave) run outside Angular (they're left unpatched in
  // zone-flags.ts so hovering doesn't re-check the whole app), so this steps back in to show / hide it.
  SetCompanyInfo(company: any, show: boolean) {
    this.ngZone.run(() => company.showInfo = show);
  }

  ngAfterViewInit() {
    // The virtual scroll viewport's height comes from a flex-grow layout that isn't settled
    // until the modal's enter transition finishes, so its initial size measurement is too small.
    // Re-check whenever the viewport element itself resizes (transition end, group toggle, etc).
    if (this.contactsViewport && typeof ResizeObserver !== 'undefined') {
      this.contactsViewportResizeObserver = new ResizeObserver(() => {
        this.contactsViewport?.checkViewportSize();
      });
      this.contactsViewportResizeObserver.observe(this.contactsViewport.elementRef.nativeElement);
    }
    setTimeout(() => this.contactsViewport?.checkViewportSize(), 400);
  }

  ngOnDestroy() {
    this.contactsViewportResizeObserver?.disconnect();
  }

  ngOnInit() {
    // A family member is always a contact, never a company - whatever the caller passed
    //if (this.selecting_for_family) this.hide_companies = true;
    this.GetData();
  }

  async GetData() {
    // Fetch family relationships if needed
    if (this.selecting_for_family && this.family_relationships.length === 0) {
      const rels: any = await this.apiService.getSpecificURL('https://app.fusionworkflow.com/assets/files/Relationships.json');
      this.family_relationships = Array.isArray(rels) ? rels : [];
    }
    // Fetch company roles if needed
    if (this.selecting_for_company && (!this.roles || this.roles.length === 0)) {
      const rolesData: any = await this.apiService.GetRoles();
      if (rolesData.success) this.roles = rolesData.data;
    }
    // Fetch team member roles if needed
    if (this.selecting_for_team_member && (!this.team_member_roles || this.team_member_roles.length === 0)) {
      const tmRolesData: any = await this.apiService.get('team_member_roles');
      if (tmRolesData.success) this.team_member_roles = tmRolesData.data;
    }
    // Fetch companies and clients
    const comp_data: any = await this.apiService.get(`companies`);
    const client_data: any = await this.apiService.get(`clients`);


    const client_groups_data: any = await this.apiService.GetGroups('clients');
    if(client_groups_data.success) this.client_groups = client_groups_data.data;

    const company_groups_data: any = await this.apiService.GetGroups('companies');
    if(company_groups_data.success) this.company_groups = company_groups_data.data;

    console.log("Client Groups: ", this.client_groups);
    console.log("Company Groups: ", this.company_groups);


    if (client_data.success && Array.isArray(client_data.data)) {
      this.clients = client_data.data;
    }
    console.log(this.clients);
    if (comp_data.success && Array.isArray(comp_data.data)) {
      this.companies = comp_data.data;
      console.log("Companies: ", this.companies);
      for (let i = 0; i < this.companies.length; i++) {
      const company = this.companies[i];
      let activeCount = 0;
      let totalCount = company.clients.length;
      company.default_client = this.clients.find(c => c.guid === company.default_client_guid);
      console.log("Company Default Client: ", company.default_client);
      for (let j = 0; j < company.clients.length; j++) {
        const company_client = company.clients[j];
        const match = this.clients.find(c => c.guid === company_client.guid);
        if (match) {
        company.clients[j] = match;
        if (match.active) activeCount++;
        } else {
        if (company_client.active) activeCount++;
        }
      }
      if(activeCount == 0) company.active_status = 0;
      if(activeCount > 0 && activeCount != totalCount) company.active_status = 1;
      if(activeCount == totalCount) company.active_status = 2;

      }

      for (let i = 0; i < this.selected_companies.length; i++) {
      const company = this.selected_companies[i];
      let activeCount = 0;
      let totalCount = company.clients.length;
      company.default_client = this.clients.find(c => c.guid === company.default_client_guid);
      console.log("Company Default Client: ", company.default_client);
      for (let j = 0; j < company.clients.length; j++) {
        const company_client = company.clients[j];
        const match = this.clients.find(c => c.guid === company_client.guid);
        if (match) {
        company.clients[j] = match;
        if (match.active) activeCount++;
        } else {
        if (company_client.active) activeCount++;
        }
      }
      if(activeCount == 0) company.active_status = 0;
      if(activeCount > 0 && activeCount != totalCount) company.active_status = 1;
      if(activeCount == totalCount) company.active_status = 2;

      }
    }
    // Set defaults for selected clients
    if (this.selecting_for_company) this.SetRoles();
    if (this.selecting_for_family) this.SetFamily();
    if (this.selecting_for_default) this.initDefaultsForCompany();
    this.CombinedData();
  }

  async SetRoles() {
    if (!this.roles || this.roles.length === 0) return;
    for (let i = 0; i < this.clients.length; i++) {
      if (!this.clients[i].role_guid) this.clients[i].role_guid = this.roles[0].guid;
    }
    for (let i = 0; i < this.selected_clients.length; i++) {
      if (!this.selected_clients[i].role_guid) this.selected_clients[i].role_guid = this.roles[0].guid;
    }
    this.initDefaultsForRoles();
  }

  initDefaultsForRoles() {
    const byRole = new Map<string, any[]>();
    for (const client of this.selected_clients) {
      const rg = client.role_guid || '';
      if (!byRole.has(rg)) byRole.set(rg, []);
      byRole.get(rg).push(client);
    }
    for (const clients of byRole.values()) {
      if (clients.length === 1 && !clients[0].is_default_for_role) {
        clients[0].is_default_for_role = true;
      }
    }
  }

  get missingDefaultRoles(): string[] {
    if (!this.selecting_for_company || this.selected_clients.length === 0) return [];
    const byRole = new Map<string, { hasDefault: boolean, roleName: string }>();
    for (const client of this.selected_clients) {
      const rg = client.role_guid || '';
      if (!byRole.has(rg)) {
        const role = this.roles.find(r => r.guid === rg);
        byRole.set(rg, { hasDefault: false, roleName: role?.title || 'Unknown Role' });
      }
      if (client.is_default_for_role) byRole.get(rg).hasDefault = true;
    }
    return Array.from(byRole.values()).filter(v => !v.hasDefault).map(v => v.roleName);
  }

  get missingDefaultContact(): boolean {
    if (!this.selecting_for_default) return false;
    return !this.selected_clients.some(c => c.default_for_company);
  }

  get canFinish(): boolean {
    if (this.missingDefaultContact) return false;
    if (!this.selecting_for_company) return true;
    return this.missingDefaultRoles.length === 0;
  }

  get finishDisabledReason(): string {
    const reasons: string[] = [];
    if (this.missingDefaultContact) reasons.push('A default contact must be selected for the company');
    if (this.missingDefaultRoles.length > 0) reasons.push('A default contact must be selected for: ' + this.missingDefaultRoles.join(', '));
    return reasons.join('. ');
  }

  getSelectedClientsForRole(role_guid: string): any[] {
    if (!role_guid) return [];
    return this.selected_clients.filter(c => c.role_guid === role_guid);
  }

  setDefaultForRole(client: any) {
    this.getSelectedClientsForRole(client.role_guid).forEach(c => c.is_default_for_role = false);
    client.is_default_for_role = true;
  }

  setDefaultForCompany(client: any) {
    this.selected_clients.forEach(c => c.default_for_company = false);
    client.default_for_company = true;
  }

  initDefaultsForCompany() {
    if (!this.default_client_guid) return;
    const match = this.selected_clients.find(c => c.guid === this.default_client_guid);
    if (match) {
      this.selected_clients.forEach(c => c.default_for_company = false);
      match.default_for_company = true;
    }
  }

  autoSetDefaultForRole(role_guid: string) {
    const peers = this.getSelectedClientsForRole(role_guid);
    if (peers.length === 1) peers[0].is_default_for_role = true;
  }

  onRoleChange(client: any, newRoleGuid: string) {
    const oldRoleGuid = client.role_guid;
    const wasDefault = client.is_default_for_role;
    client.role_guid = newRoleGuid;
    client.is_default_for_role = false;
    if (wasDefault) this.autoSetDefaultForRole(oldRoleGuid);
    this.autoSetDefaultForRole(newRoleGuid);
  }

  async SetFamily() {
    if (!this.family_relationships || this.family_relationships.length === 0) return;
    for (let i = 0; i < this.clients.length; i++) {
      if (!this.clients[i].relationship) this.clients[i].relationship = this.family_relationships[0].name;
    }
    for (let i = 0; i < this.selected_clients.length; i++) {
      let index = this.family_relationships.findIndex(item => item.name === this.selected_clients[i].relationship);
      if (index === -1) this.selected_clients[i].relationship = this.family_relationships[0].name;
      else this.selected_clients[i].relationship = this.family_relationships[index].name;
    }
  }

  RelationshipChanged(client: any) {
    let index = this.family_relationships.findIndex(item => item.name === client.relationship);
    client.relationship_opposite = this.family_relationships[index]?.opposite;
    client.relationship_changed = true;
  }

  onTeamMemberRoleChange(client: any, newRoleGuid: string) {
    client.team_member_role_guid = newRoleGuid;
    const matchingRole = this.team_member_roles.find(role => role.guid === newRoleGuid);
    client.team_member_role_title = matchingRole ? matchingRole.title : '';
    client.team_member_role_guid = matchingRole ? matchingRole.guid : '';
  }

  isClientSelected(client_guid: string): boolean {
    return this.selected_clients.some(c => c.guid === client_guid);
  }

  isCompanySelected(company_guid: string): boolean {
    //console.log("Selected Companies: ", this.selected_companies);
    return this.selected_companies.some(c => c.guid === company_guid);
  }

  toggleClient(client: any, checked: boolean) {
    const existingIndex = this.selected_clients.findIndex(c => c.guid === client.guid);
    if (checked && existingIndex === -1) {
      const newClient = { ...client };
      if (this.selecting_for_company && this.roles && this.roles.length > 0 && !newClient.role_guid) {
        newClient.role_guid = this.roles[0].guid;
      }
      if (this.selecting_for_team_member && this.team_member_roles && this.team_member_roles.length > 0 && !newClient.team_member_role_guid) {
        newClient.team_member_role_guid = this.team_member_roles[0].guid;
        newClient.team_member_role_title = this.team_member_roles[0].title;
      }
      if (this.selecting_for_family && this.family_relationships && this.family_relationships.length > 0 && !newClient.relationship) {
        newClient.relationship = this.family_relationships[0].name;
      }
      this.selected_clients.push(newClient);
      if (this.selecting_for_company) this.autoSetDefaultForRole(newClient.role_guid);
    } else if (!checked && existingIndex !== -1) {
      if (this.selecting_for_company) {
        const removedClient = this.selected_clients[existingIndex];
        const wasDefault = removedClient.is_default_for_role;
        const roleGuid = removedClient.role_guid;
        this.selected_clients.splice(existingIndex, 1);
        if (wasDefault) this.autoSetDefaultForRole(roleGuid);
      } else {
        this.selected_clients.splice(existingIndex, 1);
      }
    }
  }

  selectCompany(company: any, checked: boolean) {
    const existingIndex = this.selected_companies.findIndex(c => c.guid === company.guid);
    if (checked && existingIndex === -1) {
      const newCompany = { ...company };
      if (this.selecting_for_team_member && this.team_member_roles && this.team_member_roles.length > 0 && !newCompany.team_member_role_guid) {
        newCompany.team_member_role_guid = this.team_member_roles[0].guid;
        newCompany.team_member_role_title = this.team_member_roles[0].title;
      }

      // Set default role if needed
      this.selected_companies.push(newCompany);
    } else if (!checked && existingIndex !== -1) {
      this.selected_companies.splice(existingIndex, 1);
    }
  }

  async Finish() {
    let data: any =  {
      clients: this.selected_clients,
      companies: this.selected_companies
    };
    this.modalController.dismiss(data);
  }

  Close() {
    // Add modal dismiss or cancel logic
    this.modalController.dismiss(null);
  }



  searchTerm: string = '';
  selectedSearchTerm: string = '';

  get filteredCompanies() {
    if (!this.searchTerm) return this.companies;

    const term = this.searchTerm.toLowerCase();

    return this.companies.filter(company => {
      const nameMatches = company.name?.toLowerCase().includes(term);
      const clientMatches = (company.clients || []).some((client: any) =>
        client.display_name?.toLowerCase().includes(term)
      );
      return nameMatches || clientMatches;
    });
  }

  filteredCompanyClients(company: any) {
    const search = this.searchTerm.toLowerCase();

    // If the company name matches, show all its clients
    if (company.name.toLowerCase().includes(search)) {
      return company.clients;
    }

    // Otherwise, only return clients that match the search
    return company.clients?.filter(client =>
      client.display_name.toLowerCase().includes(search)
    );
  }


  get filteredClients() {
    if (!this.searchTerm) return this.clients;
    const term = this.searchTerm.toLowerCase();
    return this.clients.filter(c => c.display_name?.toLowerCase().includes(term));
  }

  get filteredSelectedClients() {
    if (!this.selectedSearchTerm) return this.selected_clients;
    const term = this.selectedSearchTerm.toLowerCase();
    return this.selected_clients.filter(c => c.display_name?.toLowerCase().includes(term));
  }
  get filteredSelectedCompanies() {
    console.log("Filtering selected companies with term: ", this.selectedSearchTerm);
    console.log("Selected companies before filter: ", this.selected_companies);
    if (!this.selectedSearchTerm) return this.selected_companies;
    const term = this.selectedSearchTerm.toLowerCase();
    return this.selected_companies.filter(c => c.name?.toLowerCase().includes(term));
  }

  companyExpansion: { [guid: string]: boolean } = {};

  toggleCompany(guid: string) {
    if(this.hide_contacts) return;
    this.companyExpansion[guid] = !this.companyExpansion[guid];
  }

  isCompanyExpanded(guid: string): boolean {
    if(this.hide_companies) return false;
    return !!this.companyExpansion[guid];
  }

  areAllCompanyClientsSelected(company: any): boolean {
    if (!company.clients || company.clients.length === 0) return false;
    return company.clients.every((client: any) =>
      this.selected_clients.some((c: any) => c.guid === client.guid)
    );
  }

  areSomeCompanyClientsSelected(company: any): boolean {
    if (!company.clients || company.clients.length === 0) return false;
    const selectedCount = company.clients.filter((client: any) =>
      this.selected_clients.some((c: any) => c.guid === client.guid)
    ).length;
    return selectedCount > 0 && selectedCount < company.clients.length;
  }

  toggleAllCompanyClients(company: any, checked: boolean) {
    if (!company.clients || company.clients.length === 0) return;
    company.clients.forEach((client: any) => {
      this.toggleClient(client, checked);
    });
  }

  companyGroupExpansion: { [guid: string]: boolean } = {};

  isCompanyGroupExpanded(guid: string): boolean {
    return !!this.companyGroupExpansion[guid];
  }
  

  toggleCompanyGroup(guid: string) {
    this.companyGroupExpansion[guid] = !this.companyGroupExpansion[guid];
  }

  
  clientGroupExpansion: { [guid: string]: boolean } = {};
  
  isClientGroupExpanded(guid: string): boolean {
    return !!this.clientGroupExpansion[guid];
  }
  

  toggleClientGroup(guid: string) {
    this.clientGroupExpansion[guid] = !this.clientGroupExpansion[guid];
  }

  CompanyHasGroup(guid, company) {
    return Array.isArray(company.groups) && company.groups.some((group: any) => group.guid === guid);
  }

  ClientHasGroup(guid, client) {
    return Array.isArray(client.groups) && client.groups.some((group: any) => group.guid === guid);
  }

  CombinedData() {
    this.company_groups.forEach(group => {
      group.companies = this.companies.filter(company =>
        Array.isArray(company.groups) && company.groups.some((g: any) => g.guid === group.guid)
      );
    });
    this.client_groups.forEach(group => {
      group.clients = this.clients.filter(client =>
        Array.isArray(client.groups) && client.groups.some((g: any) => g.guid === group.guid)
      );
    });
  }

  getGroupClientCompanies(group: any): any[] {
    return (group.companies || []).filter((c: any) => c.is_a_client);
  }

  getGroupNonClientCompanies(group: any): any[] {
    return (group.companies || []).filter((c: any) => !c.is_a_client);
  }

  getGroupClientContacts(group: any): any[] {
    return (group.clients || []).filter((c: any) => c.is_a_client);
  }

  getGroupNonClientContacts(group: any): any[] {
    return (group.clients || []).filter((c: any) => !c.is_a_client);
  }

  get visibleCompanyGroups(): any[] {
    return this.company_groups.filter((g: any) =>
      !g.parent_guid && (this.show_empty_groups || this.groupHasCompanies(g))
    );
  }

  get visibleClientGroups(): any[] {
    return this.client_groups.filter((g: any) =>
      !g.parent_guid && (this.show_empty_groups || this.groupHasClients(g))
    );
  }

  visibleSubGroups(parentGuid: string, isCompanyGroup: boolean): any[] {
    const list = isCompanyGroup ? this.company_groups : this.client_groups;
    return list.filter((g: any) =>
      g.parent_guid === parentGuid &&
      (this.show_empty_groups || (isCompanyGroup ? this.groupHasCompanies(g) : this.groupHasClients(g)))
    );
  }

  groupHasCompanies(group: any): boolean {
    if (group.companies && group.companies.length > 0) return true;
    return this.company_groups
      .filter((g: any) => g.parent_guid === group.guid)
      .some((g: any) => this.groupHasCompanies(g));
  }

  groupHasClients(group: any): boolean {
    if (group.clients && group.clients.length > 0) return true;
    return this.client_groups
      .filter((g: any) => g.parent_guid === group.guid)
      .some((g: any) => this.groupHasClients(g));
  }

  selectAllInCompanyGroup(group: any) {
    (group.companies || []).forEach((company: any) => this.selectCompany(company, true));
  }

  selectAllInClientGroup(group: any) {
    (group.clients || []).forEach((client: any) => this.toggleClient(client, true));
  }

  getFilteredGroupContacts(group: any): any[] {
    const term = (group.searchTerm || '').toLowerCase();
    if (!term) return group.clients || [];
    return (group.clients || []).filter((c: any) =>
      c.display_name?.toLowerCase().includes(term) || c.email?.toLowerCase().includes(term)
    );
  }

  get filteredClientCompanies(): any[] {
    const companies = this.filteredCompanies;
    return Array.isArray(companies) ? companies.filter((c: any) => c.is_a_client) : [];
  }

  get filteredNonClientCompanies(): any[] {
    const companies = this.filteredCompanies;
    return Array.isArray(companies) ? companies.filter((c: any) => !c.is_a_client) : [];
  }

  get filteredClientContacts(): any[] {
    return this.filteredClients.filter((c: any) => c.is_a_client);
  }

  get filteredNonClientContacts(): any[] {
    return this.filteredClients.filter((c: any) => !c.is_a_client);
  }

  allContactsSearchTerm: string = '';

  get sortedFilteredContacts(): any[] {
    const term = this.allContactsSearchTerm.toLowerCase();
    const list = term
      ? this.clients.filter((c: any) =>
          c.display_name?.toLowerCase().includes(term) || c.email?.toLowerCase().includes(term)
        )
      : [...this.clients];
    return list.sort((a, b) => (a.display_name || '').localeCompare(b.display_name || ''));
  }

  async presentCreateClientModal() {
    const modal = await this.modalController.create({
      component: ClientCreatePage,
      cssClass: 'tall-modal medium-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        simple_create: true
      }
    });
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data && data.data.length > 0) {
        const newClient = data.data[0];
        this.clients = [newClient, ...this.clients];
        this.toggleClient(newClient, true);
      }
    });
    return await modal.present();
  }

}
